/**
 * 	(c) 2018 TERAOKA SEIKO CO., LTD. / 株式会社 寺岡精工
 * 	CONFIDENTIAL / 社外秘
 * 	無断開示・無断複製禁止
 */
<script>
	import {USER_TYPE} from 'js/const/constants';
	/**
	 * props 引数
	 * @param {string[]} r_url - URL
	 * @param {string[]} r_messages - 表示文言
	 * @param {string[]} r_settings - 初期設定値
	 * @param {string[]} r_is_new - 新規フラグ
	 * @param {object} r_info - 編集するデータ
	 **/
	 export default {
		mixins: [
			require('js/common/wndDetailBase.mixin.vue'),
			// TABインデックス制御
			require('js/common/tabIndex.mixin.vue'),
		],
		props:{
			'r_is_first':false,
			'r_detail_sub_title':null,
			'r_init_refresh':{
				type: Boolean,
				default:false,
			},
			'r_type':null,
			'r_type_maincode':null,
			'r_comp_funcdetail':null,
			'r_comp_viewparam':null,
			'r_comp_copysearch':null,
			'r_comp_copysearch_list':null,
			'r_comp_copysearch_ifsearch':null,
			'r_comp_copysearch_listmain':null,
			'r_comp_copysearch_check':null,
			'r_enable_copymode':null,
			'r_detail_alternative_title':null,
			'r_is_subplu_code_max':0,
		},
		data:function(){
			return{
				m_bRestore: false,
				m_bCopyNew: false,
			};
		},
		mounted: function(){
			this.m_strCode = this.$refs.func.convertInitCode(this.r_info);
			this.m_strCode2 = this.$refs.func.convertInitCode2(this.r_info);
			this.m_info = this.$refs.func.convertInitData(this.r_info);

			console.log("[ wndDetail2 mounted ] " + this.m_strCode + " , " + this.m_strCode2);
			this.v_param.onEndCopyInfo();

			if(this.r_init_refresh){
				this.$refs.func.sendRefresh(this.m_strCode,this.m_strCode2);
			}
			this.$nextTick(function() {
				//! データ更新フラグの更新
				// refsに関数内でアクセスするため、DOMに画表された後に行う
				this.v_param.updateChangeDataFlag();
			});
		},
		/**
		 * @instance
		 **/
		computed: {
			type_copy:function(){
				if(this.r_type && this.r_enable_copymode){
					return this.r_type + "/copy";
				}
				if(this.r_type){
					return this.r_type;
				}
				return null;
			},
			comp_funcdetail:function(){
				if( this.r_comp_funcdetail){
					return this.r_comp_funcdetail;
				}
				return "c-funcdetail";
			},
			comp_viewparam:function(){
				if( this.r_comp_viewparam){
					return this.r_comp_viewparam;
				}
				return "c-viewparam";
			},
			comp_copysearch:function(){
				if( this.r_comp_copysearch){
					return this.r_comp_copysearch;
				}
				return "c-viewcopysearch";
			},
			// タイトルを作成
			get_title:function() {
				if (this.r_detail_alternative_title) {
					return this.r_detail_alternative_title;
				}
				return this.r_messages.title;
			},
			// 部門などの表示文言作成
			get_title_class_name:function(){
				var className = "";
				if (this.r_class_name ){
					if( typeof this.r_class_name == "string") {
						className =  this.r_detail_sub_title + ':' + this.r_class_name + '';
					}
				}else if( this.r_detail_sub_title ){
					className =  this.r_detail_sub_title;
				}
				return className;
			},
		},
		methods: {
			/**
			 *  OKボタン <br>
			 * ******* 内部処理 *******<br>
			 * postDataに引数（新規か更新か）を渡し、呼ぶ。 <br>
			 *
			 * @function  onBtnOK
			 * @instance
			 */
			onBtnOK: function(){
				console.log("onBtnOK : ");
				var is = this.v_param.validate();
				if (!is) {
					// 失敗なら
					this.setErrorMessage(this.r_messages.can_not_register)
					return;
				}
				var okCallback = function() {
					var info = this.v_param.getData();
					var extra = this.v_param.getExtraData();
					var ret = this.$refs.func.update( this.m_bNew ?  this.UPDATE_TYPE_ADD : this.UPDATE_TYPE_UP, info,	extra);

					if(ret == false){// 失敗
						console.log("Error!");
					}
				}.bind(this);

				var okCallback2 = function() {
					var info = this.v_param.getData();
					var extra = this.v_param.getExtraData();
					var ret = this.$refs.func.update(this.m_bNew ?  this.UPDATE_TYPE_ADD : this.UPDATE_TYPE_UP, info, extra);

					if(ret == false){// 失敗
						console.log("Error!");
					} else {
						this.v_param.m_bContinuousRegistflag = true;
					}
				}.bind(this);

				switch (this.r_settings.user.display_id) {
					case '030010000000': // 企業
						if (this.m_bNew) {
							var msgConfirm = this.r_messages.confirm_regist;
							// // ディーラーアカウントログインの場合
							// if (this.r_settings.user.user_type_code == USER_TYPE.DEALER) {
							// 	msgConfirm = this.r_messages.confirm_regist_warning;
							// }

							this.doCheckDialog(msgConfirm, okCallback);
						} else {
							okCallback();
						}
						break;
					case '030010010000': // 店舗
						if (this.m_bNew) {
							var msgConfirm = this.r_messages.confirm_regist;
							// // ディーラーアカウントログインの場合
							// if (this.r_settings.user.user_type_code == USER_TYPE.DEALER) {
							// 	msgConfirm = this.r_messages.confirm_regist_warning;
							// }

							this.doCheckDialogMultiButton(msgConfirm, okCallback, okCallback2);
						} else {
							okCallback();
						}
						break;
					case '030010020000': // 納品情報
						// 新規
						if (this.m_bNew) {
							var msgConfirm = this.r_messages.confirm_regist;
							// // ディーラーアカウントログインの場合
							// if (this.r_settings.user.user_type_code == USER_TYPE.DEALER) {
							// 	msgConfirm = this.r_messages.confirm_regist_warning;
							// }
							this.doCheckDialogMultiButton(msgConfirm, okCallback, okCallback2);
						// 既存
						} else {
							var msgConfirm = this.v_param.getConfirmMsg();
							if (msgConfirm != '') {
								this.doCheckDialog(msgConfirm, okCallback);
							} else {
								okCallback();
							}
						}
						break;
					case '040000000000': // 管理会社
            // 新規
						if (this.m_bNew) {
							okCallback();
						// 既存
						} else {
							var msgConfirm = this.v_param.getConfirmMsg(this.m_bNew, 'update');
							if (msgConfirm != '') {
								this.doCheckDialog(msgConfirm, okCallback);
							} else {
								okCallback();
							}
						}
            break;
					default:
						okCallback();
				}

			},
			/**
			 * 削除ボタン <br>
			 * ******* 内部処理 *******<br>
			 * postDataに引数（消去）を渡し、呼ぶ。 <br>
			 *
			 * @function  onBtnDelete
			 * @instance
			 */
			onBtnDelete: function(msgConfirm){
				console.log("onBtnDelete : ");
				if (this.v_param.validateBaseDelete) {
					// 削除時のバリデーションが定義されている
					var is = this.v_param.validateBaseDelete();
					if (!is) {
						// 失敗なら
						this.setErrorMessage(this.r_messages.can_not_register)
						return;
					}
				}

				var info = this.v_param.getData();
				var extra = this.v_param.getExtraData();
				var okCallback = function(){
					this.$refs.func.update(this.UPDATE_TYPE_DEL,info,extra,this.onUpdateEnd);
				}.bind(this);

				switch (this.r_settings.user.display_id) {
					case '040000000000': // 管理会社マスター
						var tmpMsgText = '';
						tmpMsgText += msgConfirm;
						tmpMsgText += '<br>';
						tmpMsgText += this.r_messages.confirm_delete_history;
						msgConfirm = tmpMsgText;
						break;
					case '030010020000': // 納品情報
						msgConfirm = this.r_messages.confirm_delete_product;
						break;
					default:
						break;
				}
				this.doCheckDialog( msgConfirm, okCallback);
			},
			/**
			 * 更新処理の終了
			 */
			onUpdateEnd: function(retcode, update_type, response , msg, ext){
				if(retcode == 0){ // 成功
					switch(update_type)
					{
					case this.UPDATE_TYPE_ADD: // 新規
						if(this.$refs.func.is_update_create_code){// 新規追加によるCodeの更新がある
							this.m_strCode = this.$refs.func.convertUpdateCode(response);
						}
					case this.UPDATE_TYPE_UP: // 更新
						// 表示を更新する
						this.setSuccessMessage(msg, false);
						this.$refs.func.refresh(response);
						this.$refs.v_param.m_finishFlg = true;
						switch (this.r_settings.user.display_id) {
							case '040000000000': // 管理会社マスター
							case '040000010000': // ディーラーマスター
							    this.v_param.m_bChangeLanguageFlag = true;
								break;
							case '030020010000': // アカウント管理（管理会社）
							case '030020020000': // アカウント管理（ディーラー）
								this.v_param.$refs.v_basic.m_bChangeLanguageFlag = true;
								break;
							case '040010010000': // 重大エラー番号
								this.m_strCode = this.$refs.v_param.m_info.id;
								break;
							default:
								break;
						}
						break;
					case this.UPDATE_TYPE_DEL: // 削除
						this.m_strCode = this.$refs.func.resetCode(this.m_strCode);
						this.m_strCode2 = this.$refs.func.resetCode2(this.m_strCode2);
						switch (this.r_settings.user.display_id) {
							case '030020000000': // アカウント作成(DIGI)
							case '030020010000': // アカウント作成(管理会社)
							case '030020020000': // アカウント作成(ディーラー)
							case '040000000000': // 管理会社マスター
							case '040000010000': // ディーラーマスター
							case '040000025000': // 即時メールマスター
							case '030010000000': // 企業
							case '030010010000': // 店舗
							case '030010015000': // 部門
							case '030010020000': // 納品情報
							case '040010090000': // メンテナンス管理
								this.m_info = this.$refs.func.reset(true);
								this.v_param.updateChangeDataFlag(true);
								break;
							case '040010010000': // 重大エラー番号
								this.m_info = this.$refs.func.reset(true);
								this.m_strCode = this.m_info.id;
								this.m_strCode2 = '';
								this.v_param.updateChangeDataFlag(true);
								break;
							default:
								this.m_info = this.$refs.func.reset();
						}
						this.m_bNew = true;
					default:
						this.m_info.isDelete = true;
						this.setSuccessMessage(msg);
						break;
					}
				}
				else{
					this.setErrorMessage( msg, ext )
					// return;
				}
				// スクロールトップ
				$('#detail .scroll-container > .body-container:has(.sticky-element-area)').animate({scrollTop: 0}, 500);
				// 正常終了
			},
			/**
			 * 更新処理の終了
			*/
			onRefreshEnd: function(retcode, data, msg, bNew=false){
//console.log("onRefreshEnd - " + retcode);
//console.log(data);
				if(retcode == 0){// 成功
					this.setSuccessMessage(msg);
					if ( data ) { // データが存在する
						this.m_info = this.$refs.func.convertInitData(data);

						// 連続登録
						if (this.v_param.m_bContinuousRegistflag) {
							this.m_strCode = '';
							this.m_bNew = true;
							this.v_param.updateChangeDataFlag(true);
							this.v_param.m_bContinuousRegistflag = false;
						// コピー
						} else if (this.m_bCopyNew) {
							this.m_bCopyNew = false;
							this.m_bNew = true;
							// this.r_info = this.$refs.func.reset(true);
							this.m_info = this.$refs.func.convertCopyData(this.m_info);
							this.v_param.updateChangeDataFlag(true);
						// 通常
						} else {
							if (bNew) {
								// 初期化データを生成セットしたい場合は、初期化データが飛んでくる
								this.m_bNew = true;
							} else {
								this.m_bNew = false;
							}
						}

					} else {
						// データが存在しないため新規として扱う
						// this.m_info = this.$refs.func.reset();
						switch (this.r_settings.user.display_id) {
							case '040000000000': // 管理会社マスター
							case '040000010000': // ディーラーマスター
							case '040000025000': // 即時メールマスター
							case '040010010000': // 重大エラー番号
							case '030010000000': // 企業
							case '030010010000': // 店舗
							case '030010020000': // 納品情報
								this.m_info = this.$refs.func.reset(this.m_bRestore);
								this.v_param.updateChangeDataFlag(this.m_bRestore);
								break;
							default:
								this.m_info = this.$refs.func.reset();
						}
						if ( this.m_bResetCode2 && !this.m_bNew) { // 新規フラグがファルスでかつコード2resetフラグが立っていた場合にコード２をresetする。
							this.m_strCode2 = this.$refs.func.resetCode2(this.m_strCode2);
						}
						this.m_bNew = true;
						this.m_bRestore = false;
					}
				}else{ // エラー処理
					this.setErrorMessage( msg )
				}
				// コード2resetフラグは必ずresetする。
				this.m_bResetCode2 = false;
			},
			/**
			 * 更新ボタン（リロード）
			 *
			 * @instance
			 */
			onBtnRestore: function(){
				switch (this.r_settings.user.display_id) {
					// 管理会社マスター
					// ディーラーマスター
					// 即時メールマスター
					// 企業
					// 店舗
					// 納品情報
					case '040000000000':
					case '040000010000':
					case '040000025000':
					case '030010000000':
					case '030010010000':
					case '030010020000':
						// 変更あり
						if (this.$refs.v_param.checkUpdate()) {
							var target = this;
							var okCallback = function() {
								if (target.m_bNew) {
									target.m_strCode = '';
									target.m_strCode2 = '';
									target.v_param.m_strCode = '';
									target.v_param.m_info = target.$refs.func.reset(true);
								}
								target.m_bRestore = true;
								target.$refs.func.changeItem(target.m_strCode,target.m_strCode2);
							};
							this.doCheckDialog( this.msg_confirm_move_restore, okCallback);
						// 変更なし
						} else {
							if (this.m_bNew) {
								this.m_strCode = '';
								this.m_strCode2 = '';
								this.v_param.m_strCode = '';
								this.v_param.m_info = this.$refs.func.reset(true);
							}
							this.m_bRestore = true;
							this.$refs.func.changeItem(this.m_strCode,this.m_strCode2);
						}
						return;
					// 重大エラー番号
					case '040010010000':
						// 変更あり
						if (this.$refs.v_param.checkUpdate()) {
							var target = this;
							var okCallback = function() {
								if (target.m_bNew) {
									target.m_strCode = 0;
									target.m_strCode2 = '';
									target.v_param.m_strCode = 0;
									target.v_param.m_info = target.$refs.func.reset(true);
								}
								target.m_bRestore = true;
								target.$refs.func.changeItem(target.m_strCode,target.m_strCode2);
							};
							this.doCheckDialog( this.msg_confirm_move_restore, okCallback);
						// 変更なし
						} else {
							if (this.m_bNew) {
								this.m_strCode = 0;
								this.m_strCode2 = '';
								this.v_param.m_strCode = 0;
								this.v_param.m_info = this.$refs.func.reset(true);
							}
							this.m_bRestore = true;
							this.$refs.func.changeItem(this.m_strCode,this.m_strCode2);
						}
						return;
					// アカウント管理
					case '030020000000':
					case '030020010000':
					case '030020020000':
						// 変更あり
						if (this.$refs.v_param.checkUpdate()) {
							var target = this;
							var okCallback = function() {
								if (target.m_bNew) {
									var tmpStrCode = (target.r_settings.user.user_type_code != USER_TYPE.DIGI) ? target.r_settings.user.seller_code : '';
									target.m_strCode = tmpStrCode;
									target.m_strCode2 = '';
									target.v_param.m_strCode = tmpStrCode;
									target.v_param.m_strCode2 = '';
									target.v_param.$refs.v_basic.m_strCode = tmpStrCode;
									target.v_param.$refs.v_basic.m_strCode2 = '';
									target.v_param.m_info = target.$refs.func.reset(true);
								}
								target.m_bRestore = true;
								target.$refs.func.changeItem(target.m_strCode,target.m_strCode2);
							};
							this.doCheckDialog( this.msg_confirm_move_restore, okCallback);
						// 変更なし
						} else {
							if (this.m_bNew) {
								var tmpStrCode = (this.r_settings.user.user_type_code != USER_TYPE.DIGI) ? this.r_settings.user.seller_code : '';
								this.m_strCode = tmpStrCode;
								this.m_strCode2 = '';
								this.v_param.m_strCode = tmpStrCode;
								this.v_param.m_strCode2 = '';
								this.v_param.$refs.v_basic.m_strCode = tmpStrCode;
								this.v_param.$refs.v_basic.m_strCode2 = '';
								this.v_param.m_info = this.$refs.func.reset(true);
							}
							this.m_bRestore = true;
							this.$refs.func.changeItem(this.m_strCode,this.m_strCode2);
						}
						return;
				}

				if ( this.$refs.v_param.checkUpdate() ) {
					// 変更あり
					var target = this;
					var okCallback = function(){
						target.m_bRestore = true;
						target.$refs.func.changeItem(target.m_strCode,target.m_strCode2);
					};
					this.doCheckDialog( this.msg_confirm_move_restore, okCallback);

				} else {
					// 変更なし
					this.m_bRestore = true;
					this.$refs.func.changeItem(this.m_strCode,this.m_strCode2);
				}
			},
			/**
			 * 新規追加ボタン
			 *
			 * @instance
			 */
			onBtnNewData: function(){
				this.$emit('event_close');
				var tabChange = (this.$parent.m_register_mode == this.NEW_DISP) ? false : true;
				// 「申請する」タブへ変更
				if (tabChange) this.$parent.m_register_mode = this.NEW_DISP;
				if (tabChange) this.$parent.m_tmp_register_mode = this.NEW_DISP;

				var ref = this.$refs.func;

				this.m_id = '';
				this.m_strCode = '';
				this.m_info = [];

				var ref_param = this.$refs.v_param;
				this.$nextTick(function(){
					// 一覧を更新
					if (tabChange) {
						var fn = function(){
							// ダイアログを画面中央に移動
							this.$children[1].onResizeWindow();
						}.bind(this);
						this.$parent.onBtnSelectMode(this.NEW_DISP, fn);
					} else {
						this.$parent.onBtnSelectMode(this.NEW_DISP);
					}

					ref_param.m_finishFlg = false;

					var newData = ref.manager.createNewData({});
					this.$parent.onBtnDetail(newData, true);
				});
			},
			/**
			 * 変更ボタン
			 *
			 * @instance
			 */
			onBtnEditData: function(){
				var tabChange = (this.$parent.m_register_mode == this.EDIT_DISP) ? false : true;
				// 「編集する」タブへ変更
				if(tabChange) this.$parent.m_register_mode = this.EDIT_DISP;
				if(tabChange) this.$parent.m_tmp_register_mode = this.EDIT_DISP;
				this.$refs.func.m_bRestoreEnable = true;
				this.$refs.v_param.m_finishFlg = false;
				// 変更
				this.$refs.func.editItem(this.m_strCode,this.m_strCode2);

				this.$nextTick(function(){ 
					// 一覧を更新
					if (tabChange){
						var fn = function(){
							// ダイアログを画面中央に移動
							this.$children[1].onResizeWindow();
						}.bind(this);
						if(tabChange) this.$parent.onBtnSelectMode(this.EDIT_DISP, fn);
					} else {
						if(tabChange) this.$parent.onBtnSelectMode(this.EDIT_DISP);
					}
				});
			},
			/**
			 *  エラー詳細ボタン
			 * 
			 * @instance
			 */
			onBtnErrDetail: function(){
				this.$refs.func.onBtnErrDetail();
			},
			/**
			 * コピーボタン
			 *
			 * @instance
			 */
			onBtnCopyNew: function(){
				switch (this.r_settings.user.display_id) {
					// 即時メールマスター
					// 重大エラー番号
					case '040000025000':
					case '040010010000':
						// 変更あり
						if (this.$refs.v_param.checkUpdate()) {
							var target = this;
							var okCallbackRestore = function() {
								// if (target.m_bNew) {
								// 	target.m_strCode = '';
								// 	target.m_strCode2 = '';
								// 	target.v_param.m_strCode = '';
								// 	target.v_param.m_info = target.$refs.func.reset(true);
								// }
								// // target.m_bRestore = true;
								// target.m_bCopyNew = true;
								// target.$refs.func.changeItem(target.m_strCode,target.m_strCode2);
								var okCallbackCopy = function() {
									if (target.m_bNew) {
										target.m_strCode = '';
										target.m_strCode2 = '';
										target.v_param.m_strCode = '';
										target.v_param.m_info = target.$refs.func.reset(true);
									}
									// target.m_bRestore = true;
									target.m_bCopyNew = true;
									target.$refs.func.changeItem(target.m_strCode,target.m_strCode2);
								};
								target.doCheckDialog(target.msg_confirm_move_copy, okCallbackCopy);
							};
							this.doCheckDialog( this.msg_confirm_move_restore, okCallbackRestore);
						// 変更なし
						} else {
							var target = this;
							var okCallbackCopy = function() {
								if (target.m_bNew) {
									target.m_strCode = '';
									target.m_strCode2 = '';
									target.v_param.m_strCode = '';
									target.v_param.m_info = target.$refs.func.reset(true);
								}
								// target.m_bRestore = true;
								target.m_bCopyNew = true;
								target.$refs.func.changeItem(target.m_strCode,target.m_strCode2);
							};
							target.doCheckDialog(target.msg_confirm_move_copy, okCallbackCopy);
						}
						return;
					// 管理会社マスター
					// ディーラーマスター
					// 企業
					// 店舗
					// 納品情報
					case '040000000000':
					case '040000010000':
					case '030010000000':
					case '030010010000':
					case '030010020000':
						// 変更あり
						if (this.$refs.v_param.checkUpdate()) {
							var target = this;
							var okCallback = function() {
								if (target.m_bNew) {
									target.m_strCode = '';
									target.m_strCode2 = '';
									target.v_param.m_strCode = '';
									target.v_param.m_info = target.$refs.func.reset(true);
								}
								// target.m_bRestore = true;
								target.m_bCopyNew = true;
								target.$refs.func.changeItem(target.m_strCode,target.m_strCode2);
							};
							this.doCheckDialog( this.msg_confirm_move_restore, okCallback);
						// 変更なし
						} else {
							if (this.m_bNew) {
								this.m_strCode = '';
								this.m_strCode2 = '';
								this.v_param.m_strCode = '';
								this.v_param.m_info = this.$refs.func.reset(true);
							}
							// this.m_bRestore = true;
							this.m_bCopyNew = true;
							this.$refs.func.changeItem(this.m_strCode,this.m_strCode2);
						}
						return;
					// アカウント管理
					case '030020000000':
					case '030020010000':
					case '030020020000':
						// 変更あり
						if (this.$refs.v_param.checkUpdate()) {
							var target = this;
							var okCallback = function() {
								if (target.m_bNew) {
									var tmpStrCode = (target.r_settings.user.user_type_code != USER_TYPE.DIGI) ? target.r_settings.user.seller_code : '';
									target.m_strCode = tmpStrCode;
									target.m_strCode2 = '';
									target.v_param.m_strCode = tmpStrCode;
									target.v_param.m_strCode2 = '';
									target.v_param.$refs.v_basic.m_strCode = tmpStrCode;
									target.v_param.$refs.v_basic.m_strCode2 = '';
									target.v_param.m_info = target.$refs.func.reset(true);
								}
								target.m_bRestore = true;
								target.$refs.func.changeItem(target.m_strCode,target.m_strCode2);
							};
							this.doCheckDialog( this.msg_confirm_move_restore, okCallback);
						// 変更なし
						} else {
							if (this.m_bNew) {
								var tmpStrCode = (this.r_settings.user.user_type_code != USER_TYPE.DIGI) ? this.r_settings.user.seller_code : '';
								this.m_strCode = tmpStrCode;
								this.m_strCode2 = '';
								this.v_param.m_strCode = tmpStrCode;
								this.v_param.m_strCode2 = '';
								this.v_param.$refs.v_basic.m_strCode = tmpStrCode;
								this.v_param.$refs.v_basic.m_strCode2 = '';
								this.v_param.m_info = this.$refs.func.reset(true);
							}
							this.m_bRestore = true;
							this.$refs.func.changeItem(this.m_strCode,this.m_strCode2);
						}
						return;
				}

				if ( this.$refs.v_param.checkUpdate() ) {
					// 変更あり
					var target = this;
					var okCallback = function(){
						target.m_bRestore = true;
						target.$refs.func.changeItem(target.m_strCode,target.m_strCode2);
					};
					this.doCheckDialog( this.msg_confirm_move_restore, okCallback);

				} else {
					// 変更なし
					this.m_bRestore = true;
					this.$refs.func.changeItem(this.m_strCode,this.m_strCode2);
				}
			},
		},
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/common/wndDetail2.mixin.vue